import { render } from "./InitiativeYandexMap.vue?vue&type=template&id=311d5bd4"
import script from "./InitiativeYandexMap.vue?vue&type=script&lang=js"
export * from "./InitiativeYandexMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__